var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 8.66666H20.8C25.3334 8.66666 25.7867 10.7867 26.0934 13.3733L27.2934 23.3733C27.68 26.6533 26.6667 29.3333 22 29.3333H10.0134C5.33337 29.3333 4.32003 26.6533 4.72003 23.3733L5.92004 13.3733C6.21338 10.7867 6.6667 8.66666 11.2 8.66666Z",
    stroke: "#626262",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 10.6667V5.99999C10.6666 3.99999 12 2.66666 14 2.66666H18C20 2.66666 21.3333 3.99999 21.3333 5.99999V10.6667",
    stroke: "#626262",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2133 22.7064H10.6666",
    stroke: "#626262",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.372493a4d94f47f66fb394777560b5e9.svg";
export { ForwardRef as ReactComponent };